export function findNodeTarget(nodesFromNav, nodeTarget) {
  if (nodesFromNav.length < 1) return;
  for (let i = 0; i < nodesFromNav.length; i++) {
    if (parseInt(nodesFromNav?.[i].id) === parseInt(nodeTarget)) {
      return nodesFromNav?.[i];
    } else if (
      nodesFromNav?.[i].childs &&
      nodesFromNav?.[i].childs.length > 0
    ) {
      const result = findNodeTarget(nodesFromNav?.[i].childs, nodeTarget);
      // return the result only if it's actually found otherwise keep looping
      if (result) return result;
    }
  }
}
